/* eslint-disable */
export default {
  loginButton: '登录',
  signupButton: '新用户？注册',
  version: '版本',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
